import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import cx from 'classnames';
import Typography from '@mui/material/Typography';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Interweave } from 'interweave';
import NoSsr from '@mui/material/NoSsr';
import s from './LessonSources.scss';
var LessonSources = function LessonSources(_ref // eslint-disable-line react/prop-types
) {
  var className = _ref.className,
    isSourcesExist = _ref.isSourcesExist,
    headerTitle = _ref.headerTitle,
    sourcesHTML = _ref.sourcesHTML;
  return isSourcesExist ? /*#__PURE__*/_jsx("div", {
    className: cx(s.sourcesContainer, className)
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    component: "h3",
    variant: "h5"
  }, void 0, headerTitle), /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
    tagName: "div",
    content: sourcesHTML
  }))) : null;
};
export default withStyles(s)(LessonSources);